/**
 * Options of the "Imported" filter: one per import batch, labelled `Imported <date> · <file>`.
 * Flat on purpose (`Filters` options have no group header).
 *
 * @param {{ id: string, file_name?: string|null, created_at: string }[]} [batches] Newest first.
 * @param {(key: string, values: object) => string} t
 * @param {string} [locale]
 */
export const buildImportBatchOptions = (batches = [], t, locale) => {
  const formatDate = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });

  // An invalid date would make `Intl.DateTimeFormat#format` throw during render.
  const dateOf = (iso) => {
    const date = new Date(iso);
    return Number.isNaN(date.getTime()) ? '' : formatDate.format(date);
  };

  return batches.map((batch) => ({
    value: batch.id,
    label: t('members.filters.importedLabel', {
      date: dateOf(batch.created_at),
      file: batch.file_name ?? '',
    }),
  }));
};
